// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"6f5ab93f","81":"9bc0bdbf","146":"9e53bcdd","320":"094ccb42","346":"9275ef06","544":"c9d0dc5d","554":"bce3833c","584":"d50da41a","630":"4ffc4e11","673":"a73d5a16","746":"a9ed6351","947":"418e82be","956":"a9a69f58"}[chunkId] + ".chunk.js";
};